export default __webpack_public_path__ + "static/media/ulster.e2d7d2c2.png";